import React from 'react';

/**
 * SocialLink — circular icon button for GitHub / LinkedIn / email.
 * The border ring fills with yellow on hover; icon lifts slightly.
 */
export function SocialLink({ icon, label, href = '#', ...rest }) {
  return (
    <a
      href={href}
      aria-label={label}
      target={href.startsWith('http') ? '_blank' : undefined}
      rel="noopener noreferrer"
      title={label}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '2.75rem',
        height: '2.75rem',
        borderRadius: 'var(--radius-circle)',
        border: 'var(--border-hairline) solid var(--border-default)',
        color: 'var(--text-secondary)',
        background: 'var(--white-a04)',
        transition: 'var(--t-hover)',
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.borderColor = 'var(--border-accent)';
        e.currentTarget.style.color = 'var(--accent)';
        e.currentTarget.style.background = 'var(--yellow-a08)';
        e.currentTarget.style.transform = 'translateY(-3px)';
        e.currentTarget.style.boxShadow = 'var(--glow-sm)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.borderColor = 'var(--border-default)';
        e.currentTarget.style.color = 'var(--text-secondary)';
        e.currentTarget.style.background = 'var(--white-a04)';
        e.currentTarget.style.transform = 'translateY(0)';
        e.currentTarget.style.boxShadow = 'none';
      }}
      {...rest}
    >
      {icon}
    </a>
  );
}

export default SocialLink;
